import { Component, computed, EventEmitter, OnInit, Output, Signal, inject } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { EmployeeRoleState } from '../../../../_interfaces/employee.interface';
import { ActivatedRoute, Router } from '@angular/router';
import {
  FilterButtonComponent,
  FilterGroup,
  FilterOption,
} from '../../../../shared/components/filter-button/filter-button.component';
import { updateParamsObject, updateParamsObjectToPageOne } from '../../../../shared/utils/filter-utils';
import { BoFormsModule } from '@bo/ng-forms';
import {
  EmployeeFilterParamNames,
  EmployeeFilterParams,
  generateEmployeeFilterGroups,
} from '../../../../_services/employee-service/employee-utils';

@Component({
  selector: 'app-employees-filter',
  imports: [FilterButtonComponent, BoFormsModule],
  templateUrl: './employees-filter.component.html',
})
export class EmployeesFilterComponent implements OnInit {
  readonly router = inject(Router);
  readonly route = inject(ActivatedRoute);

  @Output() query: EventEmitter<HttpParams> = new EventEmitter<HttpParams>();

  protected filterParams: Signal<EmployeeFilterParams> = computed(() => {
    const queryParams = this.route.snapshot.queryParams;
    return {
      role: queryParams[EmployeeFilterParamNames.role] ?? '',
      idnum_status: queryParams[EmployeeFilterParamNames.idnum_status] ?? '',
    };
  });

  protected hasKycFilters = computed(() => {
    return false;
  });

  protected hasRoleFilters = computed(() => {
    return false;
  });

  private queryParams = new HttpParams();
  protected filterGroup: Array<FilterGroup> = [];

  ngOnInit(): void {
    const roleQuery: string[] = this.filterParams().role.split(',');
    const statusQuery: string[] = this.filterParams().idnum_status.split(',');
    this.filterGroup = generateEmployeeFilterGroups(roleQuery, statusQuery);
  }

  handleReset(): void {
    this.queryParams = new HttpParams();

    this.router
      .navigate([], {
        queryParams: updateParamsObject(this.queryParams), // Don't reset page on filter reset
        queryParamsHandling: 'merge',
      })
      .then(() => {});
  }

  processStatus(options: Array<FilterOption>) {
    const checkedOptions = options.filter((opt) => opt.checked);
    const statusQuery: string[] = [];

    if (checkedOptions.length > 0) {
      checkedOptions.forEach((opt) => {
        if (opt.name === EmployeeFilterParamNames.idnum_status) {
          statusQuery.push(opt.value as string);
        }
      });
      // Add status and receipt filters
      if (statusQuery.length > 0) {
        this.queryParams = this.queryParams.set(EmployeeFilterParamNames.idnum_status, statusQuery.toString());
      }
    } else {
      // Clear checkedOptions from filters
      this.queryParams = this.queryParams.delete(EmployeeFilterParamNames.idnum_status);
    }
  }

  processRoles(options: Array<FilterOption>) {
    const checkedOptions = options.filter((opt) => opt.checked);
    const roleQuery: EmployeeRoleState[] = [];

    if (checkedOptions.length > 0) {
      checkedOptions.forEach((opt) => {
        if (opt.name === EmployeeFilterParamNames.role) {
          roleQuery.push(opt.value as EmployeeRoleState);
        }
      });
      // Add status and receipt filters
      if (roleQuery.length > 0) {
        this.queryParams = this.queryParams.set(EmployeeFilterParamNames.role, roleQuery.toString());
      }
    } else {
      // Clear checkedOptions from filters
      this.queryParams = this.queryParams.delete(EmployeeFilterParamNames.role);
    }
  }

  onFilter(options: Array<FilterOption>) {
    // create "clean" query params, otherwise historical queries gets added again.
    const existingParams = this.route.snapshot.queryParams;
    this.queryParams = new HttpParams().appendAll(existingParams);

    this.processRoles(options);
    this.processStatus(options);

    // Navigate with updated filters and reset page to 1
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: updateParamsObjectToPageOne(this.queryParams),
    });
  }
}
